var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalIndigoFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 214,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0h308c8.837 0 16 7.163 16 16v182c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.164 0 16 0h308c8.837 0 16 7.163 16 16v182c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z",
    fill: "#191D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.164 0 16 0h308c8.837 0 16 7.163 16 16v182c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z",
    fill: "#2C4866"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 214,
    rx: 16,
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41.587,
    x2: 283.407,
    y2: 213.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.163 7.163 0 16 0h308c8.837 0 16 7.163 16 16v182c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20 178)",
    d: "M0 0H140V16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalIndigoFront);
export default __webpack_public_path__ + "static/media/digital-indigo-front.4f9df7485bd2b1c4a7d7cc6d2fb6fd9b.svg";
export { ForwardRef as ReactComponent };